export interface ApplicabilityFleet {
  model: string[];
  version: string[];
  serialno: SerialNumber[];
}

export interface SerialNumber {
  label: string;
  realValue: string;
  version: string;
}

export interface UserCriterias {
  filterOn?: boolean;
  model: string;
  version: string;
  serialno: string;
  showNotApplicable?: boolean;
}

export enum CriteriaNames {
  MODEL = "model",
  VERSION = "version",
  SERIALNO = "serialno"
}

export type CriteriaStringValue = "model" | "version" | "serialno";

export interface CriteriaSubapplic {
  model?: {
    md5: string;
  };
  version?: {
    md5: string;
  };
  serialno?: {
    md5: string;
    from: string;
    to: string;
  };
}

export interface MatchingCriteria {
  model: string[];
  version: string[];
  serialno: string[];
}

export interface CriteriaItem {
  name: string;
  type: string;
  from?: string;
  to?: string;
  value?: string;
}
